import { type ResourceSchema, fetchSchema } from '@/lib/resources'
import { useQuery } from '@tanstack/react-query'

/** Cached forever — schemas are static between deploys. */
export function useResourceSchema(key: string | undefined) {
  return useQuery<ResourceSchema>({
    queryKey: ['admin-resource-schema', key],
    queryFn: () => fetchSchema(key!),
    enabled: Boolean(key),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: 60 * 60_000
  })
}
